module.exports = __webpack_public_path__ + "img/logoips.1b37ff94.png";